import http from '@/assets/plugin/axios'

import type { NotificationListResponse } from '@/model/notification.model'

const getNotificationsService = (page = 1, perPage = 15) => {
    return http.get<NotificationListResponse>('/api/notifications', {
        params: { page, per_page: perPage },
    })
}

const readAllNotificationsService = () => {
    return http.post<{ message: string; unread_count: number }>('/api/notifications/read-all')
}

export { getNotificationsService, readAllNotificationsService }
